<template>
  <div class="c-stamp">
    <div
      class="c-stamp__img"
      :style="{
        backgroundImage: `url(https://tuango-contest-assets.s3.amazonaws.com/fb/estrie.jpg)`
      }"
    ></div>
  </div>
</template>

<script>
export default {
  name: "Stamp"
}
</script>

<style lang="scss" scoped>
.c-stamp {
  width: 260px;
  height: 180px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 25px;
  background: white;
  position: relative;
  /*The stamp cutout will be created using crisp radial gradients*/
  background: radial-gradient(
    transparent 0px,
    transparent 4px,
    white 4px,
    white
  );

  /*reducing the gradient size*/
  background-size: 20px 20px;
  /*Offset to move the holes to the edge*/
  background-position: -10px -10px;

  &:after {
    content: "";
    position: absolute;
    left: 5px;
    top: 5px;
    right: 5px;
    bottom: 5px;
    z-index: -1;
  }
}

.c-stamp__img {
  height: 100%;
  background-color: #dfe6e9;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  //background-size: cover;
}
</style>
